export default {
    'enumerate.xpdyj': 'Ticket printer',
    'enumerate.pmdyj': 'Label printer',
    'enumerate.dbd': 'Packing bag',
    'enumerate.hc': 'take-out food',
    'enumerate.wb': 'microwave',
    'enumerate.tl': 'seasoning',
    'enumerate.cj': 'tableware',
    'enumerate.yl': 'drink'
}